import React from 'react';
import './Chip.less';

export const Chip = ({text, isSelected, isPrimary, isOutlined, onClick}) => {
	return (
		<button onClick={onClick} className={`chip 
		${
			isOutlined ? 'chip--outlined' : ''
		}
		${
			onClick ? 'chip--clickable' : ''
		} ${
			isSelected ? 'chip--selected' : ''
		} ${
			isPrimary ? 'chip--primary' : ''
		}`}>
			{text}
		</button>
	);
};
